import { CardGrid, Plus, SoftButton } from '@weareopenr/component-library';
import MenuItemCard from '../../MenuItemCard';
import MenuItemCardSkeleton from '../../MenuItemCardSkeleton';
import { IMenuItem } from 'src/types/menu.types';
import styles from './MenuItemCardContainer.module.scss';

interface IMenuItemCardContainer {
  menuId: string;
  items: IMenuItem[];
  newItemButtonTitle: string;
  handleNewItemClick: () => void;
  isNewItemHidden?: boolean;
  pendingCount?: number;
}

const MenuItemCardContainer = ({
  menuId,
  items,
  newItemButtonTitle,
  handleNewItemClick,
  isNewItemHidden,
  pendingCount = 0,
}: IMenuItemCardContainer) => {
  return (
    <CardGrid>
      {[
        ...items.map((menuItem: IMenuItem) => {
          return (
            <MenuItemCard
              {...menuItem}
              key={menuItem.itemId}
              prices={[]}
              menuId={menuId}
              parentItemId={menuItem.parentItemId}
            />
          );
        }),
        ...Array.from({ length: pendingCount }, (_, index) => <MenuItemCardSkeleton key={`pending-${index}`} />),
        !isNewItemHidden && (
          <SoftButton
            colour="blueberry"
            icon={Plus}
            size="square"
            className={styles['add-product']}
            onClick={handleNewItemClick}
            key="new"
          >
            {newItemButtonTitle}
          </SoftButton>
        ),
      ]}
    </CardGrid>
  );
};

export default MenuItemCardContainer;
